
//import Integracoes from "../../../../empreenderUI/examples/IntegracaoPage";
import { useEffect, useState } from 'react';
import Integracoes from '../../../../empreenderUI/features/IntegracaoPage/Integracoes';
import ModalInforNuvemshop from '../Modal-Integration';
import { platforms } from '../../pages/home/dataCards';
import NuvemshopIcon from '../../../../assets/imgs/integrations/nuvemshop.svg';
import ShopifyIcon from '../../../../assets/imgs/integrations/shopify.svg';
import { useDispatch, useSelector } from 'react-redux';
import ModalConfirmationNuvemshop from '../../../../components/Modal-Confirmation';
import ModalInforShopify from '../Modal-Integration';
import ModalConfirmationShopify from '../../../../components/Modal-Confirmation';
import sakImg from "../../../../assets/imgs/icons-integrations/sak.svg";
import YampiIcon from "../../../../assets/imgs/icons-integrations/yampi.png";

import ModalInforYampi from '../Modal-Integration';
import ModalConfirmationYampi from '../../../../components/Modal-Confirmation';

import ModalInforSak from '../Modal-Integration';
import ModalConfirmationSak from '../../../../components/Modal-Confirmation';
import { toast } from 'react-toastify';
import { isShopifyLoginDomain } from '../../../../utils/shopify-login';
import { translations } from '../../../../utils/language';



const IntegrationsUI = () => {

    const [visibleModalNuvemshop, setVisibleModalNuvemshop] = useState(false);
    const [visibleModalShopify, setVisibleModalShopify] = useState(false);
    const [visibleModalYampi, setVisibleModalYampi] = useState(false);
    const [visibleModalSak, setVisibleModalSak] = useState(false);

    const [dataIntegracoes, setDataIntegracoes] = useState([]);
    const statusPlatforms = useSelector(state => state.reducerGetPlatforms)
    const language = useSelector((state) => state.reducerLanguage);

    const [visibleModalConfirmationNuvemshop, setVisibleModalConfirmationNuvemshop] = useState(false)
    const [visibleModalConfirmationShopify, setVisibleModalConfirmationShopify] = useState(false)
    const [visibleModalConfirmationYampi, setVisibleModalConfirmationYampi] = useState(false)
    const [visibleModalConfirmationSak, setVisibleModalConfirmationSak] = useState(false)

    const dispatch = useDispatch()

    const isShopifyLogin = isShopifyLoginDomain();
    const tagLoja = translations["integrations-tag-loja"][language.data];

    let integracoesInfo = [
        {
            title: 'Nuvemshop',
            description: translations["integrations-card-nuvemshop"][language.data],
            icon: <img src={NuvemshopIcon} />,
            color: '#2C3357',
            appEmpreender: false,
            installed: false,
            tags: [tagLoja],
            installBtn: <label style={{ cursor: 'pointer', display: 'flex', width: 'max-content', padding: '5px 10px' }} onClick={() => setVisibleModalNuvemshop(true)}>{translations["integrations-install"][language.data]}</label>,
            unistallBtn: <label style={{ cursor: 'pointer', display: 'flex', width: 'max-content', padding: '5px 10px' }} onClick={() => setVisibleModalConfirmationNuvemshop(true)}>{translations["integrations-uninstall"][language.data]}</label>,

        },
        {
            title: 'Shopify',
            description: translations["integrations-card-shopify"][language.data],
            icon: <img src={ShopifyIcon} />,
            color: '#54EB9B',
            appEmpreender: false,
            installed: false,
            tags: [tagLoja],
            installBtn: <label style={{ cursor: 'pointer', display: 'flex', width: 'max-content', padding: '5px 10px' }} onClick={() => setVisibleModalShopify(true)}>{translations["integrations-install"][language.data]}</label>,
            unistallBtn: <label style={{ cursor: 'pointer', display: 'flex', width: 'max-content', padding: '5px 10px' }} onClick={() => setVisibleModalConfirmationShopify(true)}>{translations["integrations-uninstall"][language.data]}</label>,

        },
        {
            title: 'Yampi',
            description: translations["integrations-card-yampi"][language.data],
            icon: <img src={YampiIcon} />,
            color: '#F5F2FB',
            appEmpreender: false,
            installed: false,
            tags: [tagLoja],
            installBtn: <label style={{ cursor: 'pointer', display: 'flex', width: 'max-content', padding: '5px 10px' }} onClick={() => setVisibleModalYampi(true)}>{translations["integrations-install"][language.data]}</label>,
            unistallBtn: <label style={{ cursor: 'pointer', display: 'flex', width: 'max-content', padding: '5px 10px' }} onClick={() => setVisibleModalConfirmationYampi(true)}>{translations["integrations-uninstall"][language.data]}</label>,

        },

        {
            title: 'Sak',
            description: translations["integrations-card-sak"][language.data],
            icon: <img src={sakImg} />,
            color: '#00E673',
            appEmpreender: true,
            installed: false,
            tags: ['Empreender'],
            installBtn: <label style={{ cursor: 'pointer', display: 'flex', width: 'max-content', padding: '5px 10px' }} onClick={() => setVisibleModalSak(true)}>{translations["integrations-install"][language.data]}</label>,
            unistallBtn: <label style={{ cursor: 'pointer', display: 'flex', width: 'max-content', padding: '5px 10px' }} onClick={() => setVisibleModalConfirmationSak(true)}>{translations["integrations-uninstall"][language.data]}</label>,

        },
    ]

    if (isShopifyLogin) {
        integracoesInfo = integracoesInfo.filter(integracao => integracao.title === 'Shopify');
    }

    useEffect(() => {
        console.log("dataIntegracoes", dataIntegracoes)
    }, [dataIntegracoes])

    const deleteIntegration = (platform) => {
        dispatch({ type: "SAGA_DELETE_INTEGRATION", payload: { platform: platform } })
    }

    // const getInfor = (platform) => {

    //     switch (platform) {
    //         case "Dropi":
    //             return `${translation.integrations.loja}: ${JSON.parse(localStorage.getItem("depoimentos@login"))?.integrationDropi?.user_token}`
    //         case "Shopify":
    //             return `${translation.integrations.loja}: ${JSON.parse(localStorage.getItem("depoimentos@login"))?.integration?.url}`
    //         case "Nuvemshop":
    //             return `${translation.integrations.loja}: ${JSON.parse(localStorage.getItem("depoimentos@login"))?.integration?.url}`
    //         case "Mercadoshop":
    //             return `${translation.integrations.loja}: ${JSON.parse(localStorage.getItem("depoimentos@login"))?.integration?.url}`
    //         case "Custom":
    //             return `Site: ${JSON.parse(localStorage.getItem("depoimentos@login"))?.integration?.url}`
    //         case "Montink":
    //             return `${translation.integrations.loja}: ${JSON.parse(localStorage.getItem("depoimentos@login"))?.integration?.url}`
    //         case "Hotmart":
    //             return `${translation.integrations.loja}: ${JSON.parse(localStorage.getItem("depoimentos@login"))?.integration?.url}`
    //         case "Land Page":
    //             return `Site: ${JSON.parse(localStorage.getItem("depoimentos@login"))?.integration?.url}`
    //         case "Wix":
    //             return `${translation.integrations.loja}: ${JSON.parse(localStorage.getItem("depoimentos@login"))?.integration?.url}`
    //         case "Sak":
    //             return props.install ? `Token: ${statusPlatforms?.data[1]?.access_token?.substr(0, 5)} *************** ${statusPlatforms?.data[1]?.access_token?.substr(statusPlatforms?.data[1]?.access_token?.length - 5, statusPlatforms?.data[1]?.access_token?.length - 1)}` : null
    //         default:
    //             return `${translation.integrations.loja}: ${JSON.parse(localStorage.getItem("depoimentos@login"))?.integration?.url}`
    //     }
    // }


    return (
        <>
            <ModalInforNuvemshop platform={platforms.nuvemshop} visible={visibleModalNuvemshop} setVisibleModal={setVisibleModalNuvemshop} item={platforms.nuvemshop} />
            <ModalConfirmationNuvemshop textButtom={translations["integrations-excluir-botao"][language.data]} confirmation={() => deleteIntegration("nuvemshop")} visible={visibleModalConfirmationNuvemshop} setVisibleModal={setVisibleModalConfirmationNuvemshop} title={`${translations["integrations-excluir-integracao"][language.data]} ${translations["Nuvemshop"][language.data]}?`}
            //infor={getInfor(props.item.title == "Custom" ? translation.integrations.card.integracaoManual : props.item.title)}
            />

            <ModalInforShopify platform={platforms.shopify} visible={visibleModalShopify} setVisibleModal={setVisibleModalShopify} item={platforms.shopify} />
            <ModalConfirmationShopify textButtom={translations["integrations-excluir-botao"][language.data]} confirmation={() => deleteIntegration("shopify")} visible={visibleModalConfirmationShopify} setVisibleModal={setVisibleModalConfirmationShopify} title={`${translations["integrations-excluir-integracao"][language.data]} ${translations["Shopify"][language.data]}?`} />

            <ModalInforYampi platform={platforms.yampi} visible={visibleModalYampi} setVisibleModal={setVisibleModalYampi} item={platforms.yampi} />
            <ModalConfirmationYampi textButtom={translations["integrations-excluir-botao"][language.data]} confirmation={() => deleteIntegration("yampi")} visible={visibleModalConfirmationYampi} setVisibleModal={setVisibleModalConfirmationYampi} title={`${translations["integrations-excluir-integracao"][language.data]} ${translations["Yampi"][language.data]}?`} />

            <ModalInforSak platform={platforms.sak} visible={visibleModalSak} setVisibleModal={setVisibleModalSak} item={platforms.sak} />
            <ModalConfirmationSak textButtom={translations["integrations-excluir-botao"][language.data]} confirmation={() => deleteIntegration("sak")} visible={visibleModalConfirmationSak} setVisibleModal={setVisibleModalConfirmationSak} title={`${translations["integrations-excluir-integracao"][language.data]} ${"Sak"}?`} />
            {/* 
            {dataIntegracoes.length > 0 && <Integracoes integracoesInfo={dataIntegracoes} />}
            {dataIntegracoes.length == 0 && <Integracoes integracoesInfo={integracoesInfo} />} */}

            {statusPlatforms.loading ?
                <Integracoes integracoesInfo={integracoesInfo} /> :
                <ComponentIntegrations integracoesInfo={integracoesInfo} />
            }
        </>

    )
}

export default IntegrationsUI


const ComponentIntegrations = ({ integracoesInfo }) => {

    const [data, setData] = useState([])
    const statusPlatforms = useSelector(state => state.reducerGetPlatforms)
    const language = useSelector((state) => state.reducerLanguage);
    const [key, setKey] = useState(0)

    const getFormattedUrl = () => {
        const url = JSON.parse(localStorage.getItem("depoimentos@login"))?.integration?.url;
        if (!url) return '';
        if (url.startsWith('http://') || url.startsWith('https://')) {
            return url;
        }
        return `https://${url}`;
    };

    useEffect(() => {
        console.log("statusPlatforms teste", statusPlatforms)
        transformDataIntegrations(statusPlatforms.data)
    }, [statusPlatforms, language])

    const transformDataIntegrations = (dataPlatforms) => {
        const hasLojaTag = dataPlatforms.some(platform =>
            integracoesInfo.some(integracao =>
                platform.platform.toLowerCase() === integracao.title.toLowerCase()
            )
        );
        console.log("hasLojaTag", hasLojaTag)
        const storeUrl = getFormattedUrl();
        const teste = integracoesInfo.map(integracao => {
            const isInstalled = dataPlatforms.some(platform => platform.platform.toLowerCase() === integracao.title.toLowerCase() || integracao.title.toLowerCase() === 'shopee');
            return {
                ...integracao,
                installed: isInstalled,
                // description must stay a string — Integracoes search calls .toLowerCase()
                description: integracao.description,
                details: isInstalled && storeUrl ? { storeUrl } : undefined,
                installBtn: hasLojaTag && (integracao.tags.includes(translations["integrations-tag-loja"][language.data]) || integracao.tags.includes('Manual')) ? <label style={{ cursor: 'pointer', display: 'flex', width: 'max-content', padding: '5px 10px' }} onClick={() => toast.info(translations["integrations-existe-integracao"][language.data])}>{translations["integrations-install"][language.data]}</label> : integracao.installBtn
            };
        });

        console.log("teste", teste)
        setData(teste)
        setKey(key + 1)
    };

    return (
        <Integracoes key={key} integracoesInfo={data} />
    )
}